'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Activator": "Polaris-Picker-Activator",
  "disabled": "Polaris-Picker-Activator--disabled"
};

exports.default = styles;
